import React from 'react'
import topbird from "../assets/topbird.gif"

const Roadmap = () => {

const boxes = [
    {
        heading: "Q1 2024",
        l1:"Website",
        l2:"Token Development",
        l3:"Social Creation"
    },
    {
        heading: "Q2 2024",
        l1:"Pre-sale stages",
        l2:"Game Development",
    },
    {
        heading: "Q3 2024",
        l1:"Final sales",
        l2:"Game Release",
        l3:"Listing in BaseSwap"
    },
    {
        heading: "Q4 2024",
        l1:"Marketing",
        l2:"CEX Listing",
        l3:"New Roadmap"
    },
]


    return (
        <>
         <div className='h-full md:w-[1442px] w-full flex items-center justify-center flex-col'>
            <section className='pb-5 md:w-full w-screen bg-black md:px-10'>
                <h1 className='md:text-[5rem] text-[3rem] p-10 md:ml-16'>Roadmap</h1>
                <img src={topbird} alt="" className='h-16 w-16 ml-32'/>
                <div className='flex items-center justify-evenly gap-1 px-16 flex-wrap'>
                    {boxes.map((item, index) => (
                    <div className='h-64 w-64 bg-[#343944] rounded-lg p-5'>
                        <h1 className='font-bold'>{item.heading}</h1>
                        <ul className='mt-5 list-disc text-[#0052FF] pl-5'>
                            <li><span className='text-white'>{item.l1}</span></li>
                            <li className=' my-3'><span className='text-white'>{item.l2}</span></li>
                            <li><span className='text-white'>{item.l3}</span></li>
                        </ul>
                    </div> 
                )) }
                </div>
            </section>
            </div>
        </>
    )
}

export default Roadmap
